/* src/app/main/declaration-reports/ageing-export/ageing-export-parameters.component.scss */
/*# sourceMappingURL=ageing-export-parameters.component-65YFKBBV.css.map */
